var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWordIconify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 120,
    viewBox: "0 0 104 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.3032 11.1629H61.4059V0H54.3414L0 11.1907V108.837L54.0225 120H61.4059V108.879H96.8695C98.8778 108.767 101.111 108.949 102.835 107.498C104.217 105 103.863 101.874 103.981 99.0557V16.5768C104.229 13.3954 101.997 10.8419 99.3032 11.1629ZM39.4093 78.9628C37.4366 80.1768 34.4831 78.9069 32.1441 79.1022C30.573 69.8652 28.7418 60.6838 27.3362 51.4048C25.9539 60.4187 24.1583 69.3486 22.5753 78.3069C20.3072 78.1675 18.0273 77.9998 15.7473 77.8186C13.7861 65.5393 11.4827 53.3441 9.65149 41.0372C11.6716 40.9256 13.7034 40.828 15.7235 40.7442C16.9402 49.6327 18.3225 58.4791 19.3859 67.3815C21.0515 58.2558 22.7524 49.1303 24.4065 40.0048C26.651 39.8513 28.8956 39.7397 31.1401 39.6001C32.7113 49.0187 34.3178 58.4232 36.0189 67.7999C37.3539 58.1164 38.8304 48.4604 40.26 38.7908C42.6225 38.6931 44.9853 38.5396 47.3361 38.3721C44.6664 51.893 42.3272 65.5257 39.4093 78.9628ZM98.3586 102.252H61.4059V93.4882H92.1205V87.9069H61.4059V80.9302H92.1205V75.3488H61.4059V68.3719H92.1205V62.7908H61.4059V55.8138H92.1205V50.2327H61.4059V43.2558H92.1205V37.6744H61.4059V30.6977H92.1205V25.1164H61.4059V17.7483H98.3586V102.252Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordIconify);
export default __webpack_public_path__ + "static/media/WordIconify.928a445673ca4d872100d3ea834c4805.svg";
export { ForwardRef as ReactComponent };